import { useContext, createContext, useState, useEffect, useRef } from "react";
import { AppContext } from "../App";
import { AppContext as MainAppContext } from "../../App";
import { callApi, WEB_SOCKET_URL } from "../CoreHelper";
import { MdOutlineChat, MdOutlineClear, MdVerticalAlignTop, MdKeyboardArrowLeft, MdOutlineRefresh } from 'react-icons/md';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import PlayedCard from "../components/PlayedCard";
import CardsPlayerInfo from "../ones/CardsPlayerInfo";
import logo_wide from '../assets/logo_wide.png';
import { 
  BsFillSuitDiamondFill,
  BsFillSuitHeartFill,
  BsSuitClubFill,
  BsFillSuitSpadeFill,
  BsFillChatDotsFill,
} from 'react-icons/bs';
import { FaHandsWash } from 'react-icons/fa';
import Lastcard from "../models/Lastcard";
import UserCard from "../components/UserCard";
import CardRequester from "../components/CardRequester";
import CardDeclare from "../components/CardDeclare";
import MobileInterface from "../../MobileInterface";

export const GameContext = createContext(null);
export default function LastcardBoard(props) {

  const app = useContext(AppContext);
  const mainApp = useContext(MainAppContext);
 
  const [ boardLocked, setBoardLocked ] = useState(false);
  const [ error, setError ] = useState(null);
  const [ message, setMessage ] = useState(null);
  const [ selectedCards, setSelectedCards ] = useState([]);
  const [ showCardRequester, setShowCardRequester ] = useState(false);
  const [ showCardDeclare, setShowCardDeclare ] = useState(false);
  const [ cardRequest, setCardRequest ] = useState(null);
  const [ cardDeclaration, setCardDeclaration ] = useState(null);
  const [ pendingCardDeclaration, setPendingCardDeclaration ] = useState(null);
  const [ rambaCardDeclaration, setRambaCardDeclaration ] = useState(null);


  function ombaKarata(required) {
    setCardRequest({
      required,
      userId: app.gameData.currentPlayer,
    })
  }

  function isCurrentPlayer() {
    return (app.gameData && app.gameData.currentPlayer === Number(app.userId) && app.gameData.status === 'ongoing')

  }
  
  function getPlayerCards() {
    let cards = [];
    if(app.gameData) {
      if(app.gameData.playerId === Number(app.userId)) {
        cards = JSON.parse(app.gameData.playerData).availableCards;
      } else if(app.gameData.opponentId === Number(app.userId)) {
        cards = JSON.parse(app.gameData.opponentData).availableCards;
      }
    }

    if(cards) {
      //get cards objects
      const cardObjects = cards.map((item, i) => {
        return Lastcard.getCard(item);
      })

      cards = cardObjects;
    }

    return cards;
  }

  function getMchezo() {
    if(app.gameData) {
      return Lastcard.getCard(JSON.parse(app.gameData.boardData).mchezo);
    }
  }

  function resetSelections() {
    setSelectedCards([]);
    setCardRequest(null);
    setCardDeclaration(null);
    setPendingCardDeclaration(null);
    setRambaCardDeclaration(null);
  }

  function getScore() {
    if(app.gameData) {
      if(Number(app.userId) === app.gameData.playerId) {
        return JSON.parse(app.gameData.playerData).score;
      } else if(Number(app.userId) === app.gameData.opponentId) {
        return JSON.parse(app.gameData.opponentData).score;
      }
    }
    return 0;
  }

  async function ramba() {
    //check if there's pending special effect
    
    if(app.gameData.currentPlayer === Number(app.userId)) {
      if(
        JSON.parse(app.gameData.boardData).specialEffect &&
        JSON.parse(app.gameData.boardData).specialEffect.userId !== Number(app.userId)
      ) {
        setError("Please accept special move or select valid card");
      } else {
        //...
        if(!boardLocked) {
          setBoardLocked(true);
          setMessage('Syncing, please wait...')
          await callApi("submit-ramba", {
            userId: app.userId,
            userToken: app.userToken,
            gameId: app.gameId,
            gameType: app.gameType,
            playMode: app.playMode,
          }).then(response => {
            if(response.status === 1) {
              //refresh gamedata
              app.getGameData();
              resetSelections();
              setMessage(false);
              setError(false);
            } else {
              setError(response.msg);
              resetSelections();
            }
          })
          setBoardLocked(false);
        } else {
          setError("Not your turn to play, please wait");
        }
        //...
      }


      
    } else {
      setError("Not your turn to play, please wait..");
    }
  }

  
  async function acceptSpecialEffect() {
    if(app.gameData.currentPlayer === Number(app.userId)) {
      //...
      if(!boardLocked) {
        setBoardLocked(true);
        setMessage('Syncing, please wait...')
        await callApi("accept-special-effect", {
          userId: app.userId,
          userToken: app.userToken,
          gameId: app.gameId,
          gameType: app.gameType,
          playMode: app.playMode,
        }).then(response => {
          if(response.status === 1) {
            //refresh gamedata
            app.getGameData();
            resetSelections();
            setMessage(false);
            setError(false);
          } else {
            setError(response.msg);
            resetSelections();
          }
        })
        setBoardLocked(false);
      } else {
        setError("Not your turn to play, please wait");
      }
      //...
    } else {
      setError("Not your turn to play, please wait..");
    }
  }

  async function submitMove() {
    const isSelectionValid = Lastcard.isSelectionValid({
      allSelectedCards: selectedCards,
      selectedCard: null,
      gameData: app.gameData,
    })

    
    
    if(app.gameData.currentPlayer === Number(app.userId)) {

      
      if(isSelectionValid) {
        //...
        if(!boardLocked) {
          if(selectedCards) {
            //...
            setBoardLocked(true);
            setMessage('Syncing, please wait...')
            await callApi("submit-move", {
              userId: app.userId,
              userToken: app.userToken,
              gameId: app.gameId,
              gameType: app.gameType,
              playMode: app.playMode,
              selectedCards: JSON.stringify(selectedCards),
              cardRequest: JSON.stringify(cardRequest),
              cardDeclaration: JSON.stringify(cardDeclaration),
            }).then(response => {
              if(response.status === 1) {
                //refresh gamedata
                app.getGameData();
                resetSelections();
                setMessage(false);
                setError(false);
              } else {
                setError(response.msg);
                resetSelections();
              }
            })
            setBoardLocked(false);
            //...
          } else {
            setError("Please select a card to play");
          }
        } else {
          setError("Not your turn to play, please wait");
        }
        //...
      } else {
        setError("Invalid cards selection");
      }
      //...
      //.....
    } else {
      setError("Not your turn to play, please wait..");
    }
    
  }

  const gameContext = {
    submitMove,
    boardLocked,
    setBoardLocked,
    message,
    error,
    setError,
    setMessage,
    resetSelections,
    getMchezo,
    selectedCards,
    setSelectedCards,
    showCardRequester,
    setShowCardRequester,
    ombaKarata,
    cardRequest,
    setCardRequest,
    showCardDeclare,
    setShowCardDeclare,
    pendingCardDeclaration,
    setPendingCardDeclaration,
    rambaCardDeclaration,
    setRambaCardDeclaration,
    cardDeclaration,
    setCardDeclaration,
  }

  useEffect(() => {

  }, [ ])

  useEffect(() => {
    //called when gameData changes
    if(app.gameData) {
      if(isCurrentPlayer()) {
        //haptic
        MobileInterface.playSound('vibrate');
      }
    }
  }, [ app.gameData ])

  useEffect(() => {
    if(selectedCards) {

      //check to trigger cardRequestDialog
      if(selectedCards.length === 1) {
        //check if it's J
        const cardObj = Lastcard.getCard(selectedCards[0]);
        if(cardObj.character === 'J') {
          //allow user to request card if has more that 1 cards left
          let userCards = null;

          if(Number(app.userId) === app.gameData.playerId) {
            userCards = JSON.parse(app.gameData.playerData).availableCards;
          } else if(Number(app.userId) === app.gameData.opponentId) {
            userCards = JSON.parse(app.gameData.opponentData).availableCards;
          }

          if(userCards) {
            if(userCards.length > 2) { //more than 1 card is left (less than 2 including this played J)
              setShowCardRequester(true);
            }
          }
        }  
        
      }

      //check to trigger cardDeclaration dialog
      const canUserDeclareCard = Lastcard.canUserDeclareCard({
        selectedCards,
        gameData: app.gameData,
      });

      if(canUserDeclareCard) {
        setShowCardDeclare(true);
        setPendingCardDeclaration(canUserDeclareCard);
      }
    }
  }, [ selectedCards ])

  useEffect(() => {
    console.log(error);
  }, [ error ])

  return (
    <GameContext.Provider value={gameContext}>

      <CardDeclare/>
      <CardRequester/>
      
      <div className="CoreCardsBoard">
        <div className="container">
          
          <div className="row">
            <div className="col-md-12 d-flex justify-content-between">
              <img 
                src={logo_wide} 
                className="align-self-center"
                style={{ 
                  height:"50px", 
                  marginLeft: "0px",
                  marginRight: "10px",
                  marginTop: "10px",
                  marginBottom: "10px",  
                  width: "auto",
                  flexShrink: "0",
                }}
              />

              <div className="d-flex align-self-center justify-content-end">
                <MdOutlineRefresh 
                  style={{
                    marginLeft: "10px",
                    marginRight: "10px",
                    cursor: "pointer"
                  }} 
                  onClick={app.refresh}
                  className="mNoPadding align-self-center" 
                  size={30}
                />

                <button
                  onClick={app.navBack}
                  className="btn btn-sm core-bg-redish align-self-center d-flex"
                  style={{
                    flexShrink: "0",
                    margin: "0",
                    paddingLeft: "5px",
                    paddingRight: "5px",
                    paddingTop: "5px",
                    paddingBottom: "5px",
                    width: "auto"
                  }}
                >
                  <MdKeyboardArrowLeft className="mNoMargin mNoPadding align-self-center" size={30}/>
                </button>
              </div>
            </div>
            <div className="col-md-6">

              <div className="corePlayedCards">
                <CardsPlayerInfo type="player"/>
                <CardsPlayerInfo type="opponent"/>

                <h6 
                  style={{ 
                    fontSize: "12px", 
                    position: "absolute",
                    bottom: "0",
                    width: "100%"
                  }} 
                  className="text-center text-muted font-bold"
                >
                  Draws: {(app.gameData) ? app.gameData.drawsNumber : ""}
                </h6>


                {
                  (app.gameData) ?
                  JSON.parse(app.gameData.boardData).playedCards.slice(-6).map((item, i) => {
                    return <PlayedCard key={i} position={i} data={Lastcard.getCard(item)}/>
                  })
                  :""
                }

                
              </div>
              <div
                className="row"
              >
                <div 
                  className="col-3" 
                  style={{ padding: "10px", overflow:"hidden", minHeight: "80px" }}
                >
                  <button
                    className="btn btn-sm font-semi-bold bg-redish btn-block"
                    style={{ padding: "5px", margin: "0px", height: "100%" }}
                    onClick={() => {
                      mainApp.activateDialog({
                        message: "Are you sure you want to pick up a new card(Ramba)?",
                        onConfirm: ramba,
                      })
                    }}
                  >
                    Ramba <br/> <span style={{ opacity: "0.7" }}>Pick Card</span>
                  </button>
                </div>
                <div 
                  className="col-4 text-start" 
                  style={{ padding: "10px" }}
                >
                  {
                    (app.gameData && JSON.parse(app.gameData.boardData).cardRequest) ?
                    <>
                    {
                      (JSON.parse(app.gameData.boardData).cardRequest.userId === Number(app.userId)) ?
                      <div style={{ width: "100%" }} className="core-text-bluish">
                        <h6 style={{ fontSize: "14px" }} className="font-semi-bold">You called for {(JSON.parse(app.gameData.boardData).cardRequest.required === 'any') ? "any card" : (JSON.parse(app.gameData.boardData).cardRequest.required === 'special' ? "special card" : "")}</h6>

                        {
                          (JSON.parse(app.gameData.boardData).cardRequest.required === 'kisu') ?
                          <div style={{ width: "100%", padding: "5px" }} className="core-bg-whitish text-center"><BsFillSuitDiamondFill color="red" size={30}/></div>: ""
                        }

                        {
                          (JSON.parse(app.gameData.boardData).cardRequest.required === 'karanga') ?
                          <div style={{ width: "100%", padding: "5px" }} className="core-bg-whitish text-center"><BsSuitClubFill color="black" size={30}/></div>: ""
                        }

                        {
                          (JSON.parse(app.gameData.boardData).cardRequest.required === 'jembe') ?
                          <div style={{ width: "100%", padding: "5px" }} className="core-bg-whitish text-center"><BsFillSuitSpadeFill color="black" size={30}/></div>: ""
                        }

                        {
                          (JSON.parse(app.gameData.boardData).cardRequest.required === 'kopa') ?
                          <div style={{ width: "100%", padding: "5px" }} className="core-bg-whitish text-center"><BsFillSuitHeartFill color="red" size={30}/></div>: ""
                        }
                      </div>
                      :
                      <div style={{ width: "100%" }} className="core-text-bluish">
                        <h6 style={{ fontSize: "14px" }} className="font-semi-bold">Opponent called for {(JSON.parse(app.gameData.boardData).cardRequest.required === 'any') ? "any card" : (JSON.parse(app.gameData.boardData).cardRequest.required === 'special' ? "special card" : "")}</h6>

                        {
                          (JSON.parse(app.gameData.boardData).cardRequest.required === 'kisu') ?
                          <div style={{ width: "100%", padding: "5px" }} className="core-bg-whitish text-center"><BsFillSuitDiamondFill color="red" size={30}/></div>: ""
                        }

                        {
                          (JSON.parse(app.gameData.boardData).cardRequest.required === 'karanga') ?
                          <div style={{ width: "100%", padding: "5px" }} className="core-bg-whitish text-center"><BsSuitClubFill color="black" size={30}/></div>: ""
                        }

                        {
                          (JSON.parse(app.gameData.boardData).cardRequest.required === 'jembe') ?
                          <div style={{ width: "100%", padding: "5px" }} className="core-bg-whitish text-center"><BsFillSuitSpadeFill color="black" size={30}/></div>: ""
                        }

                        {
                          (JSON.parse(app.gameData.boardData).cardRequest.required === 'kopa') ?
                          <div style={{ width: "100%", padding: "5px" }} className="core-bg-whitish text-center"><BsFillSuitHeartFill color="red" size={30}/></div>: ""
                        }
                      </div>
                    }
                    </>: ""
                  }

                  {
                    (
                      app.gameData &&
                      JSON.parse(app.gameData.boardData).specialEffect &&
                      (Number(app.userId) === app.gameData.playerId || Number(app.userId) === app.gameData.opponentId) &&
                      JSON.parse(app.gameData.boardData).specialEffect.userId !== Number(app.userId) &&
                      app.gameData.currentPlayer === Number(app.userId)
                    ) ?
                    <>
                      <h6
                        style={{
                          fontSize: "14px"
                        }}
                        className="font-regular core-text-bluish"
                      >
                        {
                          (JSON.parse(app.gameData.boardData).specialEffect.effect === 'kunywa') ?
                          `Kunywa karata ${JSON.parse(app.gameData.boardData).specialEffect.amount}`
                          :""
                        }

                        {
                          (
                            JSON.parse(app.gameData.boardData).specialEffect.effect === 'kwangu' &&
                            JSON.parse(app.gameData.boardData).specialEffect.amount % 2 === 1
                          ) ?
                          `Kwake?`
                          :""
                        }

                        {
                          (
                            JSON.parse(app.gameData.boardData).specialEffect.effect === 'kwangu' &&
                            JSON.parse(app.gameData.boardData).specialEffect.amount % 2 === 0
                          ) ?
                          `Kwako?`
                          :""
                        }

                        {
                          (
                            JSON.parse(app.gameData.boardData).specialEffect.effect === 'stop'
                          ) ?
                          `Umepigwa stop`
                          :""
                        }
                      </h6>
                      <button
                        onClick={acceptSpecialEffect}
                        className="btn btn-sm core-bg-goldish font-semi-bold btn-block"
                        style={{
                          margin: "0px"
                        }}
                      >
                        Kubali <span style={{ opacity: "0.7" }}>Accept</span>
                      </button>
                    </>
                    :""
                  }

                  {
                    (
                      app.gameData &&
                      JSON.parse(app.gameData.boardData).specialEffect &&
                      (Number(app.userId) === app.gameData.playerId || Number(app.userId) === app.gameData.opponentId) &&
                      JSON.parse(app.gameData.boardData).specialEffect.userId === Number(app.userId) &&
                      app.gameData.currentPlayer !== Number(app.userId)
                    ) ?
                    <>
                      <h6
                        style={{
                          fontSize: "14px",
                        }}
                        className="font-regular core-text-bluish"
                      >
                        {
                          (JSON.parse(app.gameData.boardData).specialEffect.effect === 'kunywa') ?
                          `Umenywesha karata ${JSON.parse(app.gameData.boardData).specialEffect.amount}`
                          :""
                        }

                        {
                          (
                            JSON.parse(app.gameData.boardData).specialEffect.effect === 'kwangu' &&
                            JSON.parse(app.gameData.boardData).specialEffect.amount % 2 === 1
                          ) ?
                          `Kwako`
                          :""
                        }

                        {
                          (
                            JSON.parse(app.gameData.boardData).specialEffect.effect === 'kwangu' &&
                            JSON.parse(app.gameData.boardData).specialEffect.amount % 2 === 0
                          ) ?
                          `Kwake`
                          :""
                        }

                        {
                          (
                            JSON.parse(app.gameData.boardData).specialEffect.effect === 'stop'
                          ) ?
                          `Umepiga stop`
                          :""
                        }
                      </h6>
                      <h6 className="font-light text-muted" style={{ fontSize: "12px" }}>Waiting for opponent feedback...</h6>
                    </>
                    :""
                  }
                </div>
                <div className="col-5" style={{ padding: "10px" }}>
                  <h5
                    style={{
                      fontSize: "20px"
                    }}
                    className="core-text-goldish font-bold"
                  >
                    Lastcard
                  </h5>
                  {
                    (app.webSocketConnected === 0) ?
                    <h6
                      className="font-regular core-text-redish"
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      Lost connection, reconnecting... <br/>Refresh if it takes long
                    </h6>:""
                  }
                  <h6
                    className="font-light"
                    style={{
                      fontSize: "12px",
                      maxHeight: "50px",
                      overflow: "hidden",
                    }}
                  >
                    {error || message}
                  </h6>
                </div>
              </div>
            </div>

            <div className="col-md-6 " >
              

              {
                (isCurrentPlayer()) ?
                <div className="text-center" style={{ width: "100%", marginBottom: "5px" }}>
                  <h6
                    style={{
                      width: "200px",
                      margin: "0 auto",
                      padding: "5px",
                      fontSize: "14px",
                    }}
                    className="core-bg-maronish font-semi-bold"
                  >
                    YOUR TURN TO PLAY
                  </h6>
                </div>:""
              }

              {
                (getPlayerCards().length > 4) ?
                <h6 style={{ fontSize: "12px", margin: "0" }} className="text-start text-muted font-light">Scroll up or down for more cards</h6>
                :""
              }

              <div className="coreCardsRowsHolder">
                
                <div
                  className="coreCardsRow"
                >
                  {
                    (app.gameData) ?
                    <>
                    {
                      getPlayerCards().map((item, i) => {
                        if(i >= 0 && i < 4) {
                          return <UserCard data={item} key={i}/>
                        }
                      })
                    }
                    </>
                    :""
                  }
                </div>

                <div
                  className="coreCardsRow"
                >
                  {
                    (app.gameData) ?
                    <>
                    {
                      getPlayerCards().map((item, i) => {
                        if(i >= 4 && i < 8) {
                          return <UserCard data={item} key={i}/>
                        }
                      })
                    }
                    </>
                    :""
                  }
                </div>

                <div
                  className="coreCardsRow"
                >
                  {
                    (app.gameData) ?
                    <>
                    {
                      getPlayerCards().map((item, i) => {
                        if(i >= 8 && i < 12) {
                          return <UserCard data={item} key={i}/>
                        }
                      })
                    }
                    </>
                    :""
                  }
                </div>

                <div
                  className="coreCardsRow"
                >
                  {
                    (app.gameData) ?
                    <>
                    {
                      getPlayerCards().map((item, i) => {
                        if(i >= 12 && i < 16) {
                          return <UserCard data={item} key={i}/>
                        }
                      })
                    }
                    </>
                    :""
                  }
                </div>

                <div
                  className="coreCardsRow"
                >
                  {
                    (app.gameData) ?
                    <>
                    {
                      getPlayerCards().map((item, i) => {
                        if(i >= 16 && i < 20) {
                          return <UserCard data={item} key={i}/>
                        }
                      })
                    }
                    </>
                    :""
                  }
                </div>

                <div
                  className="coreCardsRow"
                >
                  {
                    (app.gameData) ?
                    <>
                    {
                      getPlayerCards().map((item, i) => {
                        if(i >= 20 && i < 24) {
                          return <UserCard data={item} key={i}/>
                        }
                      })
                    }
                    </>
                    :""
                  }
                </div>

                <div
                  className="coreCardsRow"
                >
                  {
                    (app.gameData) ?
                    <>
                    {
                      getPlayerCards().map((item, i) => {
                        if(i >= 24 && i < 28) {
                          return <UserCard data={item} key={i}/>
                        }
                      })
                    }
                    </>
                    :""
                  }
                </div>

                <div
                  className="coreCardsRow"
                >
                  {
                    (app.gameData) ?
                    <>
                    {
                      getPlayerCards().map((item, i) => {
                        if(i >= 28 && i < 32) {
                          return <UserCard data={item} key={i}/>
                        }
                      })
                    }
                    </>
                    :""
                  }
                </div>
              
              </div>

              <div 
                className="text-center" 
                style={{ 
                  width: "100%",
                }}
              >
                <button onClick={app.triggerChat} className="btn coreCardsActionBtn">
                  <BsFillChatDotsFill
                    className="mIcon"
                  /><br/>
                  Chat
                </button>
                <button onClick={submitMove} className="btn coreCardsActionBtn">
                  <MdVerticalAlignTop
                    className="mIcon"
                  /><br/>
                  Play
                </button>
                <button 
                  onClick={() => {
                    mainApp.activateDialog({
                      message: "Are you sure you want to give up this game and lose?",
                      onConfirm: app.surrenderGame,
                    })
                  }}
                  className="btn coreCardsActionBtn"
                >
                  <FaHandsWash
                    className="mIcon"
                  /><br/>
                  Give Up
                </button>
                <button onClick={resetSelections} className="btn coreCardsActionBtn">
                  <MdOutlineClear
                    className="mIcon"
                  /><br/>
                  Clear
                </button>
              </div>
            </div>

          </div>
          
        </div>
      </div>
    </GameContext.Provider>
  )
}